import { Chart } from 'highcharts';
import { AxesRange } from '@models/OpportunityReview';

const css = {
  stroke: '#CCCCCC',
  fill: '#F7F7F7',
  style: {
    cursor: undefined,
  },
};

const getCss = (zoomButtonId: string) => {
  if (zoomButtonId === zoomButtonOptions.resetButtonId) {
    return css;
  }
  return undefined;
};

export const zoomButtonOptions = {
  selectAreaButtonText: 'Select an area to zoom',
  resetButtonText: 'Reset zoom',
  selectButtonId: 'selectZoomButton',
  resetButtonId: 'resetZoomButton',
};

export const zoomButtonRender = (chart?: Chart, axesRange?: AxesRange) => {
  if (chart) {
    const { max } = chart.xAxis[0].getExtremes();

    const showSelect = checkZoomIn(axesRange, chart.axisRangeMax, max);
    chart.axisRangeMax = max;
    const zoomButtonText = showSelect ? zoomButtonOptions.selectAreaButtonText : zoomButtonOptions.resetButtonText;
    const zoomButtonId = showSelect ? zoomButtonOptions.resetButtonId : zoomButtonOptions.selectButtonId;
    const position = {
      x: chart.plotLeft + 15,
      y: chart.plotTop + 15,
    };
    zoomButton(chart, zoomButtonText, zoomButtonId, position);
    if (showSelect) {
      chart[zoomButtonOptions.resetButtonId]?.show();
      chart[zoomButtonOptions.selectButtonId]?.hide();
    } else {
      chart[zoomButtonOptions.selectButtonId]?.show();
      chart[zoomButtonOptions.resetButtonId]?.hide();
    }
  }
};

//To check if previous axesRange is not empty then compare with xAxis range max value
//else compare previous xAxis range max value with the current to check if chart zoomed in
export const checkZoomIn = (axesRange: AxesRange | undefined, previousMax: number, currentMax: number) => {
  let isZoomIn = true;
  if (axesRange?.xAxisRange.max) {
    isZoomIn = axesRange.xAxisRange.max === currentMax;
  } else if (previousMax > currentMax) {
    isZoomIn = false;
  }
  return isZoomIn;
};

export const zoomButton = (chart: Chart, zoomButtonText: string, zoomButtonId: string, position: any) => {
  chart[zoomButtonId] ??= chart.renderer
    .button(
      `${zoomButtonText}`,
      position.x,
      position.y,
      () => {
        if (zoomButtonId === zoomButtonOptions.selectButtonId) {
          chart.zoomOut();
        }
      },
      {
        zIndex: 1000000,
      },
      getCss(zoomButtonId),
      getCss(zoomButtonId),
      getCss(zoomButtonId),
      'square',
      false,
    )
    .attr({
      id: zoomButtonId,
    })
    .add();
  return chart[zoomButtonId];
};

export default zoomButtonRender;
